module.exports = __webpack_public_path__ + "0613c48.ttf";